import { SignalObject, signalObject } from "omi";

export enum LoginState {
  INITIAL,
  OTP_VERIFICATION,
}

export type LoginStoreObject = {
  email: string;
  verificationCode: string;
  state: LoginState;
  isLoading: boolean;
  error: string | undefined;
};

export function createLoginStore(): SignalObject<LoginStoreObject> {
  return signalObject({
    email: "",
    verificationCode: "",
    state: LoginState.INITIAL,
    isLoading: false,
    error: undefined,
  });
}
